export const valueCheck = (form, chkboxlength) => {
  // console.log("Form data in valueCheck:", form);
  // console.log("Checkbox length in valueCheck:", chkboxlength);

  if (form.name === "") {
    alert("이름을 확인해주세요.");
    return false;
  }
  if (form.company === "") {
    alert("회사명을 확인해주세요.");
    return false;
  }
  if (form.phone === "") {
    alert("연락처를 확인해주세요.");
    return false;
  }
  if (form.email1 === "" || form.email2 === "") {
    alert("이메일을 확인해주세요.");
    return false;
  }
  if (chkboxlength === 0) {
    alert("문의종류를 선택해주세요.");
    return false;
  }
  if (form.inquiry === "") {
    alert("문의내용을 확인해주세요.");
    return false;
  }

  // Add validation for "알게 된 경로"
  const pathCheckboxCount = [
    form.chk15,
    form.chk16,
    form.chk17,
    form.chk18,
    form.chk19,
    form.chk20,
    form.chk21,
    form.chk22,
    form.chk23,
    form.chk24,
    form.chk25,
  ].filter(Boolean).length;

  if (pathCheckboxCount === 0) {
    alert("알게 된 경로를 선택해주세요.");
    return false;
  }

  // Add validation for "답변 희망 수단"
  if (!form.preferEmail && !form.preferPhone) {
    alert("답변 희망 수단을 선택해주세요.");
    return false;
  }

  if (!form.personal) {
    alert("개인정보 수집 및 이용방침에 동의해주세요.");
    return false;
  }

  // Build strings for selected options
  const inquiryTypes = [];
  if (form.chk1) inquiryTypes.push("앱개발");
  if (form.chk2) inquiryTypes.push("웹개발");
  if (form.chk3) inquiryTypes.push(`기타 (${form.check3})`);

  const developmentTypes = [];
  if (form.chk4) developmentTypes.push("IoT/통신");
  if (form.chk5) developmentTypes.push("중개/플랫폼");
  if (form.chk6) developmentTypes.push("홈페이지");
  if (form.chk7) developmentTypes.push("GPS/원격");
  if (form.chk8) developmentTypes.push("매장관리");
  if (form.chk9) developmentTypes.push("물류/재고");
  if (form.chk10) developmentTypes.push("비즈니스");
  if (form.chk11) developmentTypes.push("의료/병원");
  if (form.chk12) developmentTypes.push("테이블 오더");
  if (form.chk13) developmentTypes.push("쇼핑몰");
  if (form.chk14) developmentTypes.push(`기타 (${form.check14})`);

  const paths = [];
  if (form.chk15) paths.push(`네이버 검색 (${form.check15})`);
  if (form.chk16) paths.push(`네이버 외 사이트 검색 (${form.check16})`);
  if (form.chk17) paths.push("네이버 블로그");
  if (form.chk18) paths.push("유튜브");
  if (form.chk19) paths.push("인스타그램");
  if (form.chk20) paths.push("전시회");
  if (form.chk21) paths.push("언론/보도자료");
  if (form.chk22) paths.push("이메일 광고");
  if (form.chk23) paths.push("지인소개");
  if (form.chk24) paths.push("배너광고");
  if (form.chk25) paths.push(`기타 (${form.check25})`);

  const templateParams = {
    name: form.name,
    company: form.company,
    phone: form.phone,
    position: form.position,
    email: form.email1 + "@" + form.email2,
    inquiry_types: inquiryTypes.join(", ") || "선택 없음",
    development_types: developmentTypes.join(", ") || "선택 없음",
    paths: paths.join(", ") || "선택 없음",
    inquiry: form.inquiry,
    prefer:
      (form.preferEmail ? "이메일" : "") +
        (form.preferEmail && form.preferPhone ? ", " : "") +
        (form.preferPhone ? "전화" : "") || "선택 없음",
  };
  return templateParams;
};
